import * as React from "react";
import { withStyles, WithStyles } from "@material-ui/core";
import styles from "../../styles/layouts/app-layout";
import Header, { OptionalProps as HeaderProps } from "../generic/header";
import { withCustomStyles } from "../hocs/with-custom-styles";
import { CustomStyles } from "../../types";

/**
 * Interface describing component props
 */
interface Props extends WithStyles<typeof styles> {
  headerProps?: HeaderProps;
  customStyles?: CustomStyles;
}

/**
 * App layout component
 *
 * @param props component props
 */
const AppLayout: React.FC<Props> = ({
  classes,
  customStyles,
  children,
  headerProps,
}) => {
  return (
    <div className={ classes.root }>
      <Header { ...headerProps }/>
      <div
        className={ classes.content }
        style={ customStyles?.content }
      >
        { children }
      </div>
    </div>
  );
}

const Styled = withStyles(styles)(AppLayout);
const CustomStyled = withCustomStyles("layouts/app-layout")(Styled);

export default CustomStyled;